/**
 * Copyright (c) 2020 CA. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
 import { modifyAlpha } from '../../utils/modifyColour';
 import { get } from 'lodash';

 export default ({ color }) => ({
  root: {
    border: `1px solid ${get(color, 'borderColor')}`,
    borderRadius: 16,
    display: 'flex',
    height: 24,
    padding: 0,
    width: 48,
  },
  rootFocused: {
    outline: `1px solid ${get(color, 'primaryButtonHover')}`,
    outlineOffset: 2,
    '& $thumb': {
      backgroundColor: get(color, 'primaryButtonHover'),
    },
  },
  switchBase: {
    padding: 3,
    color: get(color, 'borderColor'),
    '&$checked': {
      transform: 'translateX(24px)',
      color: get(color, 'primaryButtonText'),
      '& $thumb': {
        backgroundColor: get(color, 'primaryButtonText'),
      },
      '& + $track': {
        border: `1px solid ${get(color, 'borderColor')}`,
        opacity: 1,
        backgroundColor: get(color, 'primaryButtonBackground'),
        borderColor: get(color, 'primaryButtonBackground'),
        '&:before': {
          content: '""',
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          width: 16,
          height: 16,
          backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
            get(color, 'primaryButtonText'),
          )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
          left: 6,
        },
      },
      '&:hover + $track': {
        backgroundColor: get(color, 'primaryButtonHover'),
      },
      '&:active + $track': {
        backgroundColor: get(color, 'primaryButtonBackground'),
      },
    },
    '&:hover $thumb': {
      backgroundColor: get(color, 'primaryButtonHover'),
    },
    '&:active $thumb': {
      backgroundColor: `${modifyAlpha(get(color,'bodyText'), 0.3)}`,
    },
  },
  switchBaseFocused: {
    '&$checked': {
      '& + $track': {
        backgroundColor: get(color, 'primaryButtonHover'),
      },
    },
  },
  switchBaseDisabled: {
    '& $thumb': {
      backgroundColor: `${modifyAlpha(get(color,'bodyText'), 0.5)}`,
    },
    '& + $track': {
      border: `1px solid grey`,
      opacity: 1,
      backgroundColor: `${modifyAlpha(get(color,'bodyText'), 0.3)}`,
      borderColor: `${modifyAlpha(get(color,'bodyText'), 0.3)}`,
    },
    '&$checked': {
      transform: 'translateX(24px)',
      '& $thumb': {
        backgroundColor: get(color, 'primaryButtonText'),
      },
      '& + $track': {
        border: `1px solid ${modifyAlpha(get(color,'bodyText'), 0.5)}`,
        opacity: 1,
        backgroundColor: `${modifyAlpha(get(color,'bodyText'), 0.5)}`,
      },
    },
  },
  thumb: {
    backgroundColor: `${modifyAlpha(get(color,'bodyText'), 0.5)}`,
    width: 16,
    height: 16,
    boxShadow: 'none',
  },
  track: {
    border: `4px solid ${get(color, 'primaryButtonText')}`,
    borderRadius: 12,
    boxSizing: 'border-box',
    opacity: 1,
    backgroundColor: `${modifyAlpha(get(color,'bodyText'), 0.1)}`,
  },
  checked: {},
  disabled: {},
});
